import http from '@/utils/request';

/**
 * 用户名登录
 *
 * @param {*} params
 */
export const loginByUsername = (data = {}) => {
  const url = '/authority/login';

  return http.post({
    url,
    data,
  });
};

/**
 * 退出登录
 *
 * @param {*} data
 */
export const logout = (data = {}) => {
  const url = '/authority/logout';

  return http.post({
    url,
    data,
  });
};

/**
 * 修改密码
 *
 * @param {*} data
 */
export const updatePassword = (data = {}) => {
  const url = '/authority/changePwd';
  return http.post({
    url,
    data,
    loading: true,
  });
};

/**
 * 获取验证码
 *
 * @param {*} data
 */
export const getAuthorityCode = (data = {}) => {
  const url = '/authority/getCode';
  return http.post({
    url,
    data,
  });
};

// 忘记密码
export const resetPwd = (data = {}) => {
  return http.post({
    url: '/authority/resetPwd',
    data,
  });
};

// 获取验证码新(忘记密码)
export const queryCode = (data = {}) => {
  return http.post({
    url: '/authority/getVerifyCode',
    data,
  });
};

// 获取图形验证码
export const getRefreshImageCode = (data) => http.post({ url: '/authority/v1/manage/_refreshImageCode', data });

// 获取短信验证码(登录-免密登录)
export const loginSmsCode = (data = {}) => {
  return http.post({
    url: '/authority/v1/smsCode/_fetch',
    data,
  });
};

// 获取图形验证码
export const getLoginImageCode = (data) => http.post({ url: '/authority/v1/login/imageVerifyCode/_fetch', data });

/**
 * 手机登录
 *
 * @param {*} params
 */
export const loginBySms = (data = {}) => {
  const url = '/authority/v1/login/_smsLogin';
  return http.post({
    url,
    data,
  });
};
